<div class="challengeShadowDetails">
    <div>
        <span class="details-text" cvLocalizedText langSection="Challenges_Details"
            langKey="Challenge_Details">Details</span>
    </div>
    <div class="reward-content">
        <span class="challengeReward" cvLocalizedText langSection="Challenges_Details" langKey="Challenge_Reward">
            Reward:
        </span>
        <div class="gem-reward">
            <span class="challengeReward"> {{challenge?.Wager}}</span>
            <img class="gem-icon" src="../App_Themes/clearview-default/images/challenges/shadowboxing/Gems.svg"
                alt="gem" width="16" height="16" />
        </div>
    </div>
    <div>
        <span class="challengeEnds" cvLocalizedText langSection="Challenges_Details" langKey="Ends">
            Ends:
        </span>
        <span class="challengeEnds">
            {{endDateFormatted}}
        </span>
    </div>
</div>

<div class="progress-section">
    <span class="your-progress" cvLocalizedText langSection="Challenges_Details" langKey="Your_Progress">Your
        Progress:</span>
    <div class="progress-container">
        <div class="user-score-progress">
            <div class="progress-avatar-score">
                <img class="avatar-img"
                    [src]="imageSrc + '&w=56&h=56'"
                    alt="User Avatar" width="56" height="56" />
                <div #todayScore class="score-text" (mouseover)="toggleTooltip(true, 'today-score')"
                    (mouseleave)="toggleTooltip(false, 'today-score')">
                    <div>
                        <span class="sb-text-score" cvLocalizedText langSection="Challenges_Details"
                            langKey="Todays_Score">
                            Today's Score:
                        </span>
                    </div>
                    <div>
                        <span class="sb-score">
                            {{ todayScoreValue }}
                        </span>
                    </div>
                    <span cvLocalizedText langSection="Challenges_Details" langKey="Lower_Better" [ngClass]="{
                        'health-points-tooltip': true,
                        'display-tooltip': showMetricGoalTooltip && challenge.MetricDefaultDirection == 0,
                        'today-score-tooltip': true
                      }">
                        Lower is better
                    </span>
                    <span cvLocalizedText langSection="Challenges_Details" langKey="Higher_Better" [ngClass]="{
                        'health-points-tooltip': true,
                        'display-tooltip': showMetricGoalTooltip && challenge.MetricDefaultDirection == 1,
                        'today-score-tooltip': true
                      }">
                        Higher is better
                    </span>
                </div>
            </div>
            <div class="progress-daily-goal">
                <div class="goal-text">
                    <div>
                        <span class="sb-text-score" cvLocalizedText langSection="Challenges_Details"
                            langKey="Daily_Goal">
                            Daily Goal:
                        </span>
                    </div>
                    <div>
                        <div class="sb-score">{{ dailyGoal }}</div>
                    </div>
                </div>
                <img class="goal-img"
                    src="../App_Themes/clearview-default/images/challenges/shadowboxing/shadow_boxing_progress.svg"
                    alt="Progress Icon" width="56" height="56" />
            </div>
        </div>

        <div *ngIf="challenge?.shadowBoxing" class="progress-info">
            <div *ngFor="let scenario of getFilteredScenarios()" class="progress-bar-container" #progressContainer
                (mouseover)="toggleTooltip(true, 'progress')" (mouseleave)="toggleTooltip(false, 'progress')">
                <div class="progress-bar" [ngStyle]="getProgressBarStyles(scenario.current, scenario.hp)">
                </div>
                <div class="progress-text">{{ scenario.hp - scenario.current }}/{{ scenario.hp }}</div>
                <span cvLocalizedText langSection="Challenges_Details" langKey="Shadow_Health_Points" [ngClass]="{
                    'health-points-tooltip': true,
                    'display-tooltip': showTooltip
                  }">
                    Shadow Health Points
                </span>
            </div>
            <div class="progress-date-range">
                <span class="shadow-dates">
                    {{ startDateFormatted}} - {{ endDateFormatted }}
                </span>
            </div>
            <div class="progress-punch-button" #punchContainer (mouseover)="toggleTooltip(true, 'punch')"
                (mouseleave)="toggleTooltip(false, 'punch')">
                <button type="button" class="btn btn-primary punch-button"
                    [disabled]="!challenge?.shadowBoxing?.hasPunch || challenge?.ChallengeEnded" 
                    (click)="givePunch()">
                    <img class="punch-icon"
                        src="../App_Themes/clearview-default/images/challenges/shadowboxing/punch_icon.svg"
                        alt="Punch Icon" width="16" height="16" />
                    <span cvLocalizedText langSection="Challenges_Details" langKey="Punch_Button">Punch</span>
                </button>
                <span cvLocalizedText langSection="Challenges_Details" langKey="Punch_Tooltip_Button" [ngClass]="{
                    'health-points-tooltip': true,
                    'display-tooltip': showButtonTooltip && (!challenge?.shadowBoxing?.hasPunch || challenge?.ChallengeEnded),
                    'punch-button-tooltip': true
                  }">
                    Beat the daily goal to earn.
                </span>
            </div>
        </div>
    </div>
</div>